<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :key="pageKey"
    :formsConfig="formsConfig"
    :hot-key-grid-tab-index="2"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Sales Order"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="model.CustomerName"
      />
    </template>

    <gc-tabs
      :tabs="tabs"
      :selected-index.sync="selectedIndex"
      v-if="applicationMode == 'GcorpRoam'"
    />

    <div>
      <dx-data-grid
        class="dx-card wide-card"
        :data-source="AlmondcoInshellSalesOrderLotAssignmentDetails"
        :show-borders="false"
        :focused-row-enabled="false"
        :column-auto-width="true"
        :column-hiding-enabled="true"
        :hover-state-enabled="true"
        :columns="columns"
        :height="gridHeight"
        @toolbar-preparing="onToolbarPreparing($event)"
        @content-ready="addGridNoResults($event)"
        ref="'salesorderedigrid'"
      >
        <DxSearchPanel :visible="true" :highlight-case-sensitive="true" />
        <dx-paging :page-size="50" />
        <dx-pager :show-page-size-selector="true" :show-info="true" />

        <template #add-lot-button>
          <div>Hello</div>
        </template>
        <template #primaryImageTemplate="{ data }">
          <div class="image-cell">
            <GcGridProductImage
              :ItemCode="data.data.ItemCode"
              :HasPrimaryImage="data.data.HasPrimaryImage"
              :Description="data.data.Description"
            />
          </div>
        </template>
        <template #item-select-template="{ data }">
          <div class="toolbar-auto-complete">
            <span class="title">{{ data.Description }}</span>
            <span class="sub-title" style="color: grey">{{
              data.ItemCode
            }}</span>
          </div>
        </template>

        <template #statusTemplate>
          <gc-status-chip :status="statusFriendly" />
        </template>
      </dx-data-grid>
    </div>
  </gc-main-layout>
</template>

<script>
import validationEngine from "devextreme/ui/validation_engine";

import BaseViewMixin from "../../v1/_mixins/base.view";
import { mapGetters } from "vuex";
import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import { AlmondcoSalesService } from "../../_services/api/sales/almondco-sales.service";
import { SalesOrderEDIService } from "../../_services/api/sales/sales-order-edi.service";
import { SalesOrderBatchAllocationsService } from "../../_services/api/sales/sales-order-batch-allocations.service";

class SalesOrderLotAssignmentDetail {
  constructor(
    lotNo,
    itemCode,
    description,
    hasPrimaryImage,
    lotSequenceNo,
    recordId,
  ) {
    this.LotNo = lotNo;
    this.ItemCode = itemCode;
    this.Description = description;
    this.HasPrimaryImage = hasPrimaryImage;
    this.LotSequenceNo = lotSequenceNo;
    this.RecordId = recordId || "00000000-0000-0000-0000-000000000000";
  }
}

let getFilterExpressionForArray = (fieldName, arr) => {
  let expression = "";
  for (let index = 0; index < arr.length; index++) {
    if (index == 0) {
      expression = `${fieldName} eq '` + arr[index] + "'";
    } else {
      expression = expression + ` or ${fieldName} eq '` + arr[index] + "'";
    }
  }
  return expression;
};

export default {
  props: {},
  components: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      noDataMessage: {
        addNew: {
          class: "add-new",
          title: "No Lots Assigned",
          message: "Get Started, Assign a Lot",
        },
      },
      AlmondcoInshellSalesOrderLotAssignmentDetails: [],
      model: {
        ItemCode: "",
        ItemDescription: "",
        ItemHasPrimaryImage: false,
        LotNo: null,
        Status: "A",
        Name: "",
        CompanyCode: "",
        BranchCode: "",
        SalesOrderCode: "",
      },
      toolbar: {
        addLot: {
          onClick: this.onAddLot,
          text: "Add Lot",
          type: "default",
          icon: "plus",
          stylingMode: "contained",
        },
        removeLot: {
          onClick: this.onRemoveLot,
          text: "Remove Lot",
          type: "default",
          icon: "minus",
          stylingMode: "contained",
        },
        edit: {
          icon: "edit",
          onClick: () => {
            this.$router.push({
              path: `/almondco-inshell-sales-order-lot-assignment/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: () => {
            this.$logger.trackEventButtonClickSave();
            this.saveAlmondcoInshellBinLotAssignment();
          },
        },
        audit: {
          icon: "clock",
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged,
            );
          },
        },
      },
      menu: {
        icon: "overflow",
      },

      selectedCode: null,
      isEDIOrder: false,
      isBatchAllocationVisible: false,
    };
  },
  async created() {
    this.selectedIndex = 3;
    this.model.Name = `Sales Order # ${this.baseView.id}`;
    // await this.getEdiOrder();

    await SalesOrderBatchAllocationsService.getSalesOrderDetailsByCode({
      filter: `SalesOrderCode eq ${this.baseView.id} and IsBatchProduct ne 'No'`,
      top: 1,
    }).then(async (so) => {
      if (so.data.value.length === 0) this.isBatchAllocationVisible = false;
      else {
        await SalesOrderBatchAllocationsService.getBatchAllocationRule().then(
          async (res) => {
            if (res.data.value.length > 0) {
              if (res.data.value[0].RuleAction !== "N") {
                this.isBatchAllocationVisible = true;
              } else {
                this.isBatchAllocationVisible = false;
              }
            }
          },
        );
      }
    });

    await this.getSalesOrder();
    this.loadExistingLotAssignments();
  },

  computed: {
    ...mapGetters({ applicationMode: "profile/applicationMode" }),
    statusFriendly() {
      let status =
        this.model.Status == "" ? "D" : this.model.Status.toUpperCase();
      if (status !== "X" && this.model.Status !== "C") {
        if (
          this.model.IsLockedForPicking !== undefined &&
          this.model.IsLockedForPicking.toUpperCase() === "Y"
        ) {
          status = "L";
        }
      }

      return status;
    },
    soItemsDataSource() {
      return SalesOrderService.dataSourceConfig(
        "api/SalesOrderDetailCompanyBranch",
        {
          sort: [{ selector: "ItemCode", desc: false }],
          filter: [
            ["SalesOrderCode", "=", this.model.SalesOrderCode],
            ["CompanyCode", "=", this.model.CompanyCode],
            ["BranchCode", "=", this.model.BranchCode],
          ],
        },
      );
    },
    headerFormColCount() {
      return this.model.Status == "X" ? 1 : 2;
    },

    tabs() {
      return [
        {
          text: "Order",
          path: `/sales-order/review/${this.baseView.id}`,
          applicationFeatureCode: "SalesOrder",
        },
        // {
        //   text: "Details",
        //   path: `/sales-order/review/${this.baseView.id}/details`,
        //   applicationFeatureCode: "SalesOrder",
        //   visible: this.isTablet,
        // },
        {
          text: "Batch Allocation",
          path: `/sales-order-batch-allocations/${this.baseView.mode}/${this.baseView.id}`,
          applicationFeatureCode: "SalesOrder",
          disabled: !this.isBatchAllocationVisible || this.model.Status === "P",
        },
        {
          text: "EDI",
          path: `/sales-order-edi/${this.baseView.id}`,
          applicationFeatureCode: "SalesOrderEDI",
          disabled: !this.isEDIOrder,
        },

        {
          text: "Lot Assignment",
          path: `/almondco-inshell-sales-order-lot-assignment/${this.baseView.mode}/${this.baseView.id}`,
          applicationFeatureCode: "AlmondcoInshellSalesOrderLotAssignment",
        },
      ];
    },
    columns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "Item",
          dataField: "Description",
          cellTemplate: "primaryImageTemplate",
          gcType: "String",
          gcSubType: "PrimaryRecord",
        },
        {
          gcLabel: "Item",
          dataField: "ItemCode",
          gcSubType: "HiddenCode", // GCS-RelatedRecordCodeHidden
          gcType: "String",
          width: 100,
        },
        {
          gcLabel: "Description",
          dataField: "Description",
          gcSubType: "HiddenCode", // GCS-RelatedRecordCodeHidden
          gcType: "String",
          width: 100,
        },
        {
          gcLabel: "Lot No",
          dataField: "LotNo",
          width: 300,
          gcType: "String",
        },
        {
          gcLabel: "Lot Sequence No",
          dataField: "LotSequenceNo",
          width: 300,
          gcType: "String",
        },
      ]);
    },
    headerFormItems() {
      let items = [
        {
          itemType: "group",
          caption: "",
          colCount: this.headerFormColCount,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "ItemCode",
                  ref: "itemCode",
                  visible: this.model.Status !== "X",
                  cssClass: "toolbar-itemcode-label",
                  validationRules: [
                    {
                      type: "required",
                      message: "Item Code is required",
                    },
                  ],
                  editorType: "dxSelectBox",
                  editorOptions: {
                    dataSource: this.soItemsDataSource, // Item DataSource
                    valueExpr: "ItemCode",
                    displayExpr: "Description",
                    searchExpr: ["ItemCode", "Description"],
                    searchMode: "contains",
                    showClearButton: true,
                    itemTemplate: "item-select-template",
                    searchEnabled: true,
                    onValueChanged: this.onItemCodeValueChanged,

                    width: 300,
                    placeholder: "Item Code",
                  },
                  label: {
                    text: "Item Code",
                    visible: false,
                  },
                },
              ],
            },

            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "LotNo",
                  ref: "LotNo",
                  cssClass: "toolbar-itemcode-label-1",
                  validationRules: [
                    {
                      type: "required",
                      message: "Lot No is required",
                    },
                  ],
                  editorType: "dxNumberBox",
                  editorOptions: {
                    // width: 400,
                    placeholder: "Lot No",
                  },
                  label: {
                    text: "Lot No",
                    visible: false,
                  },
                },
              ],
            },
          ],
        },
      ];

      return items;
    },
  },

  methods: {
    async loadExistingLotAssignments() {
      this.AlmondcoInshellSalesOrderLotAssignmentDetails = [];
      let result =
        await AlmondcoSalesService.getAlmondcoInshellSalesOrderLotAssignmentByeSalesOrderCode(
          this.model.SalesOrderCode,
        );

      if (result.data.value.length > 0) {
        let items = [...new Set(result.data.value.map((x) => x.ItemCode))];
        let productListFilterValues = getFilterExpressionForArray(
          "ItemCode",
          items,
        );
        var filter =
          "(" +
          productListFilterValues +
          ") and BranchCode eq '" +
          this.model.BranchCode +
          "' and CompanyCode eq '" +
          this.model.CompanyCode +
          "'";

        let { data } = await AlmondcoSalesService.getItemDataByItemCodes(
          filter,
        );

        let itemDictionary = {};

        this.$logger.debug("Data", data);
        items.forEach((item) => {
          itemDictionary[item] = data.value.find((x) => x.ItemCode == item);
        });

        for (var i = 0; i < result.data.value.length; i++) {
          var gridRecord = new SalesOrderLotAssignmentDetail(
            result.data.value[i].LotNo,
            result.data.value[i].ItemCode,
            itemDictionary[result.data.value[i].ItemCode].Description,
            itemDictionary[result.data.value[i].ItemCode].HasPrimaryImage,
            result.data.value[i].LotSequenceNo,
            result.data.value[i].RecordId,
          );

          this.AlmondcoInshellSalesOrderLotAssignmentDetails.push(gridRecord);
        }
      }
    },
    async getEdiOrder() {
      let { data } = await SalesOrderEDIService.getSalesOrderEDIByCode(
        this.baseView.id,
      );

      if (data.value.length > 0) {
        this.isEDIOrder = true;
      }
    },
    async onItemCodeValueChanged(e) {
      // eslint-disable-next-line no-debugger
      // debugger;
      this.model.ItemCode = e.value;

      let itemData = e.component
        .getDataSource()
        .items()
        .find((x) => x.ItemCode == e.value);

      if (itemData) {
        this.model.ItemDescription = itemData.Description;
        this.model.ItemHasPrimaryImage = itemData.HasPrimaryImage;
      }
    },
    onItemCodeClicked(e) {
      this.model.ItemDescription = e.itemData.Description;
    },
    repaintGrid() {
      if (this.$refs["salesorderedigrid"]) {
        let grid = this.$refs["salesorderedigrid"].instance;
        grid.repaint();
      }
    },

    async getSalesOrder() {
      let response = await SalesOrderService.getByCode(this.baseView.id);

      let data = response.data.value[0];
      this.model.Status = data.Status;
      this.model.CompanyCode = data.CompanyCode;
      this.model.BranchCode = data.BranchCode;
      this.model.SalesOrderCode = data.Code;
      this.model.DateChanged = data.DateChanged;
      this.model.DateCreated = data.DateCreated;
      this.model.ChangedBy = data.ChangedBy;
      this.model.CreatedBy = data.CreatedBy;

      if (data.IsEDIOrder === "Y") this.isEDIOrder = true;

      this.refreshView();
    },

    backButtonFunction() {
      this.$logger.debug(`Form dirty:  ${this.dirty}`);
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/sales-order",
      });
    },
    // eslint-disable-next-line no-unused-vars
    async onAddLot(e) {
      let validationResult = validationEngine.validateGroup("headerFormData");

      if (!validationResult.isValid) {
        this.addErrorMessagesFromValidationResult(validationResult);
        this.displayValidationSummary();
        return;
      }

      if (
        this.AlmondcoInshellSalesOrderLotAssignmentDetails.find(
          (x) => x.LotNo == this.model.LotNo,
        )
      ) {
        this.displayValidationSummary([
          "Lot " + this.model.LotNo + " already exists within this Sales Order",
        ]);
        return;
      }

      try {
        await AlmondcoSalesService.validateLotAssignment(
          this.model.LotNo,
          this.model.SalesOrderCode,
          this.model.ItemCode,
        );
      } catch (error) {
        var ruleMessage =
          error && error.data
            ? error.data
            : "Lot " +
              this.model.LotNo +
              " cannot be assigned to this Sales Order.";
        this.displayValidationSummary([ruleMessage]);
        return;
      }

      let result =
        await AlmondcoSalesService.getAlmondcoInshellSalesOrderLotAssignment(
          this.model.LotNo,
        );

      this.$logger.debug("result", result);

      if (
        result.data.value.length > 0 &&
        result.data.value[0].SalesOrderCode !=
          parseInt(this.model.SalesOrderCode)
      ) {
        this.displayValidationSummary([
          "Lot " +
            this.model.LotNo +
            " is already assigned to Sales Order " +
            result.data.value[0].SalesOrderCode,
        ]);
        return;
      }

      let result2 =
        await AlmondcoSalesService.getAlmondcoInshellBinLotAssignment(
          this.model.LotNo,
        );
      this.$logger.debug("result2", result2);
      if (result2.data.length == 0) {
        this.displayValidationSummary([
          "Lot " + this.model.LotNo + " does not exist",
        ]);
        return;
      }

      for (var i = 0; i < result2.data.length; i++) {
        var gridRecord = new SalesOrderLotAssignmentDetail(
          result2.data[i].LotNo,
          this.model.ItemCode,
          this.model.ItemDescription,
          this.model.ItemHasPrimaryImage,
          result2.data[i].LotSequenceNo,
        );

        this.AlmondcoInshellSalesOrderLotAssignmentDetails.push(gridRecord);
      }
    },
    // eslint-disable-next-line no-unused-vars
    async onRemoveLot(e) {
      // validate Lot Not exists
      if (!this.model.LotNo) {
        this.displayValidationSummary(["Please specify Lot No"]);
        return;
      }

      let lotNoExistsInDetailLines =
        this.AlmondcoInshellSalesOrderLotAssignmentDetails.find(
          (x) => x.LotNo == this.model.LotNo,
        );
      if (!lotNoExistsInDetailLines) {
        this.displayValidationSummary([
          "Lot " + this.model.LotNo + " does not exist in this Sales Order",
        ]);
        return;
      }

      let result =
        await AlmondcoSalesService.getAlmondcoInshellBinLotAssignment(
          this.model.LotNo,
        );

      if (result.data.length === 0) {
        this.displayValidationSummary([
          "Lot " + this.model.LotNo + " does not exist",
        ]);
        return;
      } else {
        let filteredDetails =
          this.AlmondcoInshellSalesOrderLotAssignmentDetails.filter(
            (x) => x.LotNo !== this.model.LotNo,
          );

        this.AlmondcoInshellSalesOrderLotAssignmentDetails = filteredDetails;
      }
      this.$notify(
        `Lot ${this.model.LotNo} removed from the list Successfully`,
        "success",
      );
      this.model.LotNo = null;
      this.model.ItemCode = "";
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;

      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      let itemsToRemoveFromToolBar = ["searchPanel"];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name),
      );

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,
        {
          location: "after",
          template: "statusTemplate",
        },
        {
          options: this.toolbar.audit,
          location: "after",
          widget: "dxButton",
          visible: this.baseView.mode == "review",
        },
        {
          options: this.toolbar.edit,
          location: "after",
          widget: "dxButton",
          visible: this.baseView.mode == "review" && this.model.Status !== "C",
        },
        {
          options: this.toolbar.save,
          location: "after",
          widget: "dxButton",
          visible: this.baseView.mode !== "review",
        },

        {
          widget: "dxForm",
          location: "before",
          cssClass: "gc-header-toolbar-form-wrapper",
          disabled: this.baseView.mode == "review" ? true : false,
          visible:
            this.formsConfig.editableOption && this.baseView.mode !== "review",
          options: {
            maxWidth: 600,
            formData: this.model,
            items: this.headerFormItems,
            requiredMark: "",
            validationGroup: "headerFormData",
            labelLocation: "left",
          },
          locateinmenu: "auto",
        },
        {
          options: this.toolbar.addLot,
          location: "before",
          widget: "dxButton",

          visible:
            this.formsConfig.editableOption &&
            this.baseView.mode !== "review" &&
            this.model.Status !== "X",
          ref: "addLotButton",
        },
        {
          options: this.toolbar.removeLot,
          location: "before",
          widget: "dxButton",
          visible:
            this.formsConfig.editableOption && this.baseView.mode !== "review",
          ref: "removeLotButton",
        },
      );
    },
    saveAlmondcoInshellBinLotAssignment() {
      let self = this;
      let payload = {
        SalesOrderCode: this.model.SalesOrderCode,
        AlmondcoInshellSalesOrderLotAssignmentDetails:
          this.getLotAssignmentDetailsPayload(),
      };

      this.showLoading(true);
      AlmondcoSalesService.saveAlmondcoInshellBinLotAssignment(
        payload,
        this.model.SalesOrderCode,
      )
        .then(() => {
          self.showLoading(false);
          self.$notify(
            `Lot Assignment for Sales Order ${self.model.SalesOrderCode} Successfully Saved`,
            "success",
          );
          self.loadExistingLotAssignments();
          self.setIgnoreRouteChangeConfirmation();
          self.$router.push({
            path: `/almondco-inshell-sales-order-lot-assignment/review/${this.baseView.id}`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "Save sales order Failed");
        });
    },
    getLotAssignmentDetailsPayload() {
      return this.AlmondcoInshellSalesOrderLotAssignmentDetails.map((x) => {
        return {
          ItemCode: x.ItemCode,
          LotNo: x.LotNo,
          LotSequenceNo: x.LotSequenceNo,
          RecordId: x.RecordId,
        };
      });
    },
  },
};
</script>
<style lang="scss">
.gc-header-toolbar-form-wrapper .toolbar-itemcode-label-1 {
  margin-left: 30px;
}
</style>
